import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { StringUtils } from '@/common/utils/StringUtils';
import { Box, Link } from '@mui/material';

export const InfoTooltip = ({ fieldDef, formValues }) => {
  const { navigateTo } = useNavState();
  
  if (!fieldDef.headerTooltip) return null;

  const renderSegment = (segment, idx) => {
    if (segment.text) return <span key={idx}>{segment.text}</span>;

    const displayValue =
      segment.isLink && segment.linkDisplayField
        ? formValues[segment.linkDisplayField]
        : formValues[segment.field];

    if (segment.isLink) {
      const linkId = formValues[segment.linkEntityId];

      if (!linkId) {
        return <span key={idx}>{displayValue || 'N/A'} ({segment.field})</span>;
      }

      return (
        <Link
          key={idx}
          component="button"
          sx={{ cursor: 'pointer', textDecoration: 'underline' }}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            navigateTo(
              `${segment.linkModule}/${StringUtils.toKebabConvention(segment.linkEntity)}`,
              { entityId: linkId, mode: Mode.DETAIL }
            );
          }}
        >
          {displayValue} ({segment.field})
        </Link>
      );
    }

    return <span key={idx}>{displayValue} ({segment.field})</span>;
  };

  return (
    <Box sx={{ fontSize: 14 }}>
      {fieldDef.headerTooltip.segments.map(renderSegment)}
    </Box>
  );
};